module.exports = __webpack_public_path__ + "static/media/YB5M14_1.434fc9e5.jpg";